import {
  CButton,
  CSelect,
  CCardHeader,
  CCol,
  CLabel,
  CRow,
  CSpinner,
  CForm,
  CInput,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Auth from "src/auth";
import { apiCall } from "src/_apiConfig/apiCall";

const TransferLot = () => {
  const [loading, setloading] = useState(false);
  const [emailIDList, setemailIDList] = useState([]);
  const [emailID, setemailID] = useState("");
  const [viewListDetails, setviewListDetails] = useState();
  const [fileEvent, setFileEvent] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [remark, setremark] = useState("");

  let { lotId } = useParams();
  let decrypted = window.atob(lotId);
  const { authenticated } = Auth();
  const history = useHistory();

  const TransferLotToBidder = async () => {
    let e = fileEvent;
    if (e !== false) {
      if (authenticated) {
        e.preventDefault();
        // setSelectedFile(e.target.files[0]);
        if (emailID !== "") {
          if (remark !== "") {
            const details = emailIDList.find(
              (data) => data.emailId === emailID
            );
            const files = e.target.files;
            const formData = new FormData();
            const header = new Headers();
            header.append("Accept", "application/json");
            formData.append("file", files[0]);

            // lotId: Number(decrypted),
            // transferFromUserId: Number(authenticated.district),
            // transferToUserId: Number(details.userId),
            // comments : remark

            const response = await apiCall(
              //`LotTransfer/TransferLotToBidder/${decrypted}/${authenticated.district}/${details.userId}/test/${e.target.files[0].name}`,
              `LotTransfer/add/${Number(decrypted)}/${
                e.target.files[0].name
              }/${Number(authenticated.district)}/${Number(
                details.userId
              )}/${remark}`,
              "POST",
              header,
              formData
            );
            await response.text();
            if (response.status === 200) {
              alert("Lot transfer Successfully!");
              setSelectedFile();
              setFileEvent(false);
              // history.push("/lotlist");
              history.push(`/lotlistview/${lotId}`, {
                from: window.location.href,
              });
            } else {
              alert("Error to upload file!");
            }
          } else {
            alert("Pleas enter remark");
          }
        } else {
          alert("Pleas select emailid to transfer lot!");
        }
      }
    } else {
      alert("Please Choose A File!");
    }
  };

  const getLotDetails = async () => {
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `LotDetails/getLotDetails?$filter=lotId eq ${decrypted}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setviewListDetails(jsonobj[0]);
    }
  };

  const getEmailIdBidder = async () => {
    setloading(true);
    const header = new Headers();

    const response = await apiCall(`Bidder/getBidders`, "GET", header, null);

    const jsonobj = await response.json();

    if (response.status === 200) {
      setemailIDList(jsonobj);
    }
    setloading(false);
  };

  useEffect(() => {
    getLotDetails();
    getEmailIdBidder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitHandler = async (e) => {
    e.preventDefault();
    setloading(true);
    const details = emailIDList.find((data) => data.emailId === emailID);
    if (details) {
      const header = new Headers();
      header.append("Content-Type", "application/json");
      const response = await apiCall(
        "LotTransfer/add",
        "POST",
        header,
        JSON.stringify({
          lotId: Number(decrypted),
          transferFromUserId: Number(authenticated.district),
          transferToUserId: Number(details.userId),
          comments: remark,
        })
      );

      const jsonobj = await response.json();

      if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
        history.push(`/lotlistview/${lotId}`, {
          from: window.location.href,
        });
      }
      setloading(false);
    } else {
      setloading(false);
    }
  };
  return (
    <>
      {loading ? (
        <CSpinner className="spinner-grow" color="success" />
      ) : (
        <>
          <CCardHeader>
            <CRow className="pt-3" xl={12}>
              <CCol xl={10}>
                <h3>Transfer Lot </h3>
              </CCol>
            </CRow>
            <hr />

            {viewListDetails && (
              <>
                <CRow className="md-3 mt-3">
                  <CCol xl={2}>
                    <CLabel
                      className="col-sm-12 col-form-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Lot number :
                    </CLabel>
                  </CCol>
                  <CCol xl={2}>
                    <CInput
                      value={
                        viewListDetails.lotNo === null
                          ? " "
                          : viewListDetails.lotNo
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                </CRow>
                <CRow className="md-3 mt-3">
                  <CCol xl={2}>
                    <CLabel
                      className="col-sm-12 col-form-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Tender number :
                    </CLabel>
                  </CCol>
                  <CCol xl={2}>
                    <CInput
                      value={
                        viewListDetails.tenderNo === null
                          ? " "
                          : viewListDetails.tenderNo
                      }
                      disabled
                      id="exampleFormControlInput1"
                    />
                  </CCol>
                </CRow>
                <CRow className="md-3 mt-3">
                  <CCol xl={2}>
                    <CLabel
                      className="col-sm-12 col-form-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Remarks :
                    </CLabel>
                  </CCol>
                  <CCol xl={4}>
                    <CInput
                      id="exampleFormControlInput1"
                      onChange={(e) => setremark(e.target.value)}
                    />
                  </CCol>
                </CRow>
                <CRow className="md-3 mt-3">
                  <CCol xl={2}>
                    <CLabel
                      className="col-sm-12 col-form-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Upload Document :
                    </CLabel>
                  </CCol>
                  <CCol xl={4} style={{ marginLeft: "12px" }}>
                    <input
                      name="file"
                      id="inputGroupFile01"
                      type="file"
                      className="custom-file-input"
                      onChange={(e) => {
                        setFileEvent(e);
                        setSelectedFile(e.target.files[0]);
                      }}
                    />
                    <label
                      className="custom-file-label "
                      htmlFor="inputGroupFile01"
                    >
                      {selectedFile ? selectedFile.name : <>Choose file</>}
                    </label>
                  </CCol>
                </CRow>
              </>
            )}
            <CForm onSubmit={submitHandler}>
              <CRow className="md-3 mt-3">
                <CCol xl={2}>
                  <CLabel
                    htmlFor="formFile"
                    className="col-sm-12 col-form-label"
                  >
                    Email ID:
                  </CLabel>
                </CCol>
                <CCol xl={4}>
                  <CSelect
                    aria-label="Default select example"
                    onChange={(e) => setemailID(e.target.value)}
                  >
                    <option value="">Select Email ID</option>

                    {emailIDList
                      .filter(
                        (data) =>
                          data.userId !== authenticated.district &&
                          data.isApproved === true
                      )
                      .map((data, key) => (
                        <option key={key} value={data.emailId}>
                          {data.emailId}
                        </option>
                      ))}
                  </CSelect>
                </CCol>
              </CRow>
              <CRow className="md-3 mt-3 mb-2">
                <CCol xl={1}> </CCol>

                <CCol>
                  <CButton
                    color="success"
                    //  type="submit"
                    onClick={() => TransferLotToBidder()}
                  >
                    Transfer
                  </CButton>
                  <CButton
                    className="ml-2"
                    color="info"
                    onClick={() => history.push(`/adduserfortransfer/${lotId}`)}
                    type="submit"
                  >
                    Add User
                  </CButton>
                  <CButton
                    className="ml-2"
                    color="dark"
                    onClick={() => history.goBack()}
                  >
                    Go Back
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardHeader>
        </>
      )}
    </>
  );
};
export default TransferLot;
